/*
 * @Author: 张玉婷
 * @Date: 2022-03-21 17:53:15
 * @LastEditTime: 2022-03-22 10:48:27
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\cesium\tdtLayers\index.ts
 */
import * as Cesium from 'cesium';
import { mapIp, token, subdomains, } from '@/configs/mapConfig';

export default class TdtLayer extends Cesium.UrlTemplateImageryProvider {
  constructor (layer: string) {
    super({
      url: `${mapIp}/DataServer?T=${layer}&x={x}&y={y}&l={z}&tk=${token}`,
      tilingScheme: new Cesium.WebMercatorTilingScheme(),
      subdomains,
      maximumLevel: 18,
    });
  }
}
